var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ApiBase = window.zooz_api;
class ProviderConfigurationsApi extends ApiBase {
    constructor() {
        super(...arguments);
        this.fetchProviderConfigurations = () => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.get(`${this.resourcePath}`, {}, this.defaultConfig);
            return response.data;
        });
    }
    get resourcePath() {
        return `/accounts/${this.accountId}/provider-configurations`;
    }
}
export default new ProviderConfigurationsApi();
